import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineSmallerAlt = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="110px"
        height="2px"
        viewBox="0 0 110 2"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M108.8,0.4c-0.1,0-0.3-0.1-0.3-0.1c-0.2,0.1-0.3,0-0.3-0.1c-0.1-0.2-0.6-0.1-0.8-0.1c-0.3,0.3-0.7,0-1,0
        		c-0.2,0-0.5,0.1-0.6,0.1c-0.5-0.1-1.1-0.1-1.6-0.1c-0.3,0-0.5,0-0.7-0.2c-0.1,0.1-0.1,0.2-0.2,0.4c-0.6-0.3-1.3-0.3-2-0.2
        		c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1-0.1-0.1-0.1-0.1-0.1c-0.4,0-0.8,0.1-1.1,0.1
        		c-0.6-0.1-1.1,0-1.6,0c-0.6,0-1.2,0.1-1.5-0.1c-0.3,0-0.5,0.1-0.7,0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0.1-0.3,0.2-0.7,0.1
        		c-0.2,0-0.4-0.1-0.7-0.1c-0.3,0-0.7,0-0.8,0.1c-0.3-0.1-0.5-0.1-0.8-0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1-0.1-0.1-0.2-0.2-0.2
        		c-0.3,0-0.6,0-0.6,0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0c-0.4-0.1-0.8-0.2-1.2,0c0,0-0.1,0-0.2,0c-0.3-0.1-0.6,0-0.9,0
        		c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0.1-0.5,0.1-1.5,0c0,0.1,0,0.1-0.1,0.2c-0.8-0.1-1.5-0.2-2.3,0c-0.5-0.1-1.2,0.1-1.6-0.1
        		c-0.3,0-0.5,0.1-0.7,0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.4,0-0.8-0.1-1.1,0c-0.4,0-0.7,0-1-0.1
        		c-0.1,0-0.2,0-0.4-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.4-0.1-0.7-0.1-1.1-0.2c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.1-0.6,0.2
        		c0,0-0.1-0.1-0.2-0.2c-0.3,0-0.5,0.1-0.7,0.1c-0.2,0-0.3-0.1-0.4-0.1c-0.3,0-0.5,0.1-0.7,0.1c-0.9-0.1-1.9,0-2.8-0.1
        		c-0.1,0-0.3,0-0.4,0c-0.6,0.2-1.3,0-1.9,0c-0.5-0.2-0.7,0-1,0.1c-0.4-0.2-0.7-0.3-1.2-0.1c-0.1,0-0.2,0-0.3,0
        		c-0.5-0.1-0.9,0-1.2,0.2c-0.1-0.1-0.2-0.2-0.2-0.2c-0.6,0.1-1.1,0-1.7,0c-0.7,0-1.4,0.1-2.1,0c-0.4,0.1-0.8,0-1.2-0.1
        		c-0.1,0-0.4,0-0.4,0c-0.4,0.3-0.7,0.1-1,0C57.1,0.3,57,0.3,56.9,0c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4-0.2-1.1,0.1-1.5-0.2
        		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3-0.1-0.6-0.2-0.9-0.3c-0.5,0.2-1.1,0-1.7,0.1c0,0,0,0.1,0,0.1c-0.5,0-0.9,0-1.2-0.2
        		c-0.3,0-0.5,0.3-0.9,0.2c-0.5-0.2-0.6,0.1-0.8,0.2c-0.3-0.1-0.5-0.4-0.9-0.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3,0.1-0.5,0.1-0.7,0.1
        		C47.1,0.2,47,0.1,47,0.1c-0.3,0.1-0.6,0.1-0.8,0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1-0.1-0.2-0.2-0.3-0.2
        		c-0.5,0.2-1,0.2-1.4,0.1c-0.7-0.1-1.3-0.1-1.8,0c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.4,0.2-0.7,0.1c-0.1-0.1-0.3-0.1-0.4-0.2
        		c-0.3,0.1-0.5,0.2-0.7,0.2c-0.3-0.1-0.6-0.1-1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.6,0
        		c-0.4,0-0.8-0.2-1,0.1c-0.4-0.1-1,0-1.4-0.1c-0.2-0.1-0.4-0.1-0.4,0c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1
        		c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0-0.6-0.1-0.8-0.1c-0.5,0-0.7,0-0.9,0.3
        		c0,0-0.1,0-0.2,0c0-0.1,0-0.2,0-0.3c-0.3,0-0.4,0-0.6,0.1c-0.1,0-0.3,0.1-0.4,0c-0.1,0-0.2-0.1-0.3-0.2c-0.3,0.1-0.5,0.2-0.7,0.3
        		c-0.2,0-0.5,0-0.8-0.1c-0.7-0.1-0.7-0.1-1,0.1c-0.2-0.2-0.7-0.2-1-0.1c-0.3,0.1-0.5,0-0.8,0c-0.4,0-0.7-0.1-1.1,0
        		c-0.2,0.1-0.4,0-0.6,0c-0.4-0.1-0.5,0-0.6,0.1c-0.7,0.1-1.3-0.2-2-0.2c0.1,0.1,0.1,0.1,0.2,0.2c-0.6,0.1-0.8,0-1-0.2
        		c-0.3,0.1-0.5,0.1-0.9,0.1c-0.1,0-0.2,0-0.2,0c-0.3,0.2-0.5,0.1-0.8,0c-0.1,0-0.5,0-0.5,0c-0.1,0.2-0.5,0.1-0.5,0.1
        		c-0.3,0.2-0.5-0.1-0.8,0c-0.3,0-0.6,0.1-0.9,0c-0.2-0.1-0.7,0-1,0c-0.4,0-0.7-0.1-1.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
        		c-0.3-0.1-0.4-0.1-0.7-0.2c-0.3,0.3-0.7,0.2-1.2,0.1c-0.2,0-0.4-0.1-0.7-0.1c0.1,0.1,0.1,0.1,0.2,0.2c-0.3,0-0.7,0-0.8-0.1
        		c-0.4-0.2-0.6-0.1-1,0C8,0.4,7.5,0.4,7,0.4c-0.2,0-0.4-0.1-0.6-0.2C6,0.3,5.7,0.4,5.4,0.3C4.9,0.3,4,0.2,3.6,0.3
        		c-0.3,0-0.6,0-0.7-0.1c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0,0.2c-0.6,0-1.1-0.1-1.5-0.1C0.9,0.3,0.7,0.3,0.5,0.4C0.3,0.5,0,0.6,0,0.7
        		l0.7,0.2c0.4,0,1,0.1,1.6,0.1c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.2,0.1C2.5,1,2.8,1,3.2,1c0.2,0,0.5,0,0.8,0c0,0,0.1,0,0.2,0
        		c0,0,0,0,0,0C4.4,1,4.8,1,5,1c0.3,0,0.6,0,1-0.2C6.3,0.9,6.5,1,6.7,1c0.5,0,1,0,1.4-0.1c0.4-0.1,0.7-0.2,1.1,0C9.3,1,9.6,1,10,1
        		C9.9,0.9,9.9,0.9,9.8,0.8c0.3,0,0.5,0.1,0.7,0.1C11,1,11.4,1,11.7,0.7c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.2-0.1
        		c0,0.1,0.1,0.1,0,0.1c0,0,0,0,0,0c0.1,0,0.3,0.1,0.4,0.1c0.1-0.1,0.2-0.1,0.3-0.2C13,0.9,13.3,1,13.8,0.9c0.3,0,0.8-0.1,1,0
        		c0.4,0.1,0.7,0.1,0.9,0c0.3,0,0.5,0.2,0.8,0c0.1,0,0.5,0.1,0.6-0.1c0,0,0.1,0,0.2,0c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1
        		c0,0,0.1,0,0.1,0.1c0,0,0,0-0.1,0.1c0.1,0,0.2,0,0.3,0C18,1,18.2,1,18.5,0.9c0,0,0.1,0,0.2,0c0.5,0,0.6,0,1-0.1
        		C19.9,1,20.2,1.1,20.8,1c-0.1-0.1-0.1-0.1-0.2-0.2c0.8,0,1.3,0.3,2.1,0.2c0.1-0.2,0.3-0.2,0.6-0.1c0.2,0,0.4,0.1,0.7,0
        		c0.4-0.1,0.7,0,1.1,0c0.3,0,0.5,0,0.9,0c0.3-0.1,0.8,0,1,0.1c0.4-0.2,0.4-0.2,1.1-0.1c0.3,0,0.6,0.1,0.8,0.1
        		c0.3-0.1,0.5-0.2,0.8-0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6-0.1c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.2,0
        		c0.2-0.2,0.4-0.3,0.9-0.3C32.4,0.9,32.7,1,33,1c0.1,0,0.3,0,0.4-0.1c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1
        		c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.4,0,0.4-0.1c0.1-0.1,0.3-0.1,0.5,0c0.4,0.2,1,0,1.4,0.1c0.3-0.2,0.7-0.1,1.1-0.1c0.2,0,0.4,0,0.6,0
        		c0.2,0,0.3,0,0.5,0c0.1-0.1,0.2-0.1,0.3-0.2c0.3,0.1,0.7,0.1,1,0.2c0.2-0.1,0.5-0.2,0.7-0.2C40.8,0.8,41,0.9,41.1,1
        		c0.3,0.1,0.4-0.2,0.8-0.1c0.2,0,0.5,0,0.8,0.1c0.6-0.1,1.2-0.1,1.9,0c0.5,0.1,1,0,1.5-0.1c0.1,0.1,0.2,0.2,0.3,0.3
        		c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0,0,0.1,0.1,0.2,0.1c0.2,0,0.4-0.1,0.7-0.1
        		c0.1,0.1,0.2,0.1,0.4,0.2c0,0,0,0,0,0c-0.1-0.1,0-0.2,0-0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.1,0.5,0.1,0.7,0.2
        		c0.2-0.1,0.3-0.3,0.8-0.2c0.4,0.1,0.6-0.1,0.9-0.2C52.4,0.9,52.8,1,53.3,1c0-0.1,0-0.1,0-0.1C53.9,0.8,54.5,1,55,0.8
        		c0.3,0.1,0.6,0.2,1,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.5,0.2,1.1,0,1.5,0.2c0.2-0.1,0.3-0.2,0.5-0.3C58.4,1,58.5,1,59.2,0.8
        		c0.3,0.1,0.7,0.3,1.1,0c0,0,0.3,0,0.4,0c0.3,0,0.6,0.1,1,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.8,0.1,1.5,0,2.2,0
        		c0.6,0,1.1,0.1,1.7,0c0,0,0.1,0.1,0.2,0.2c0.3-0.1,0.7-0.3,1.2-0.2c0.1,0,0.2,0,0.3,0c0.5-0.2,0.9-0.1,1.2,0.1
        		c0.3-0.1,0.6-0.4,1.1-0.1c0.6-0.1,1.3,0.2,1.9-0.1c0.1,0,0.3,0,0.4,0c1,0.1,2,0,3,0.1c0.2,0,0.5-0.1,0.8-0.1c0.1,0,0.2,0.1,0.4,0.1
        		c0.2,0,0.4,0,0.7-0.1C77.2,0.9,77.2,1,77.3,1c0.2-0.1,0.4-0.1,0.6-0.2c0,0,0.1,0,0.1,0c0.4,0.1,0.7,0.1,1.1,0.2
        		c0-0.1,0.1-0.2,0.1-0.3c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.7,0.1,1.1,0.1c0.3,0,0.7,0,1.1,0.1c0,0,0.1-0.1,0.2-0.2
        		c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0,0-0.1,0-0.1-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0
        		c-0.1-0.1,0-0.2,0.3-0.2c0,0.1,0,0.2,0.1,0.3c-0.2,0-0.3,0-0.4,0c0.4,0.2,1.1,0,1.6,0.1c0.8-0.2,1.6-0.1,2.3,0c0-0.1,0-0.1,0.1-0.2
        		c1.1,0.1,1.1,0.1,1.6,0c0.1,0,0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.9,0c0,0,0.1,0,0.2,0c0.4-0.2,0.8-0.1,1.2,0c0.1,0,0.3,0,0.5,0
        		c0.2,0,0.4,0,0.7,0c0-0.2,0.3-0.2,0.6-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.2-0.1,0.3-0.2,0.5-0.2c0.3,0.1,0.5,0.1,0.8,0.2
        		c0.1-0.2,0.5-0.2,0.8-0.1c0.2,0,0.5,0.1,0.7,0.1c0.4,0.1,0.6,0,0.7-0.1c0.2,0,0.4,0.1,0.7,0.1c0.2,0,0.4,0,0.7-0.1
        		c0.4,0.2,1,0.1,1.6,0.1c0.6,0,1.1-0.1,1.7,0c0.3,0,0.7,0,1.1-0.1c0,0,0.1,0.1,0.1,0.1c0.2-0.1,0.3-0.1,0.5-0.1
        		c0.1,0,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.7-0.1,1.4-0.1,2.1,0.2c0.1-0.1,0.1-0.2,0.2-0.4c0.2,0.1,0.4,0.2,0.8,0.2
        		c0.5,0,1.1-0.1,1.6,0.1c0.2,0,0.4,0,0.7-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0-0.1,0-0.1c0-0.2-0.2-0.3-0.5-0.3c-0.1,0-0.2-0.1-0.4-0.1
        		C109,0.3,108.9,0.4,108.8,0.4z M4.4,0.8C4,0.8,3.9,0.8,4,0.6C4.2,0.7,4.3,0.7,4.4,0.8z M6.4,0.5c-0.1,0-0.1,0-0.2,0
        		c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.2,0.1C6.5,0.4,6.4,0.5,6.4,0.5z M9,0.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0.2,0
        		C9,0.7,9,0.7,9,0.7z M10.9,0.7c-0.1-0.2-0.1-0.2,0.3-0.2C11.1,0.6,11.1,0.6,10.9,0.7z M18.4,0.9c0,0-0.1,0-0.1,0.1
        		c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1C18.4,0.8,18.4,0.9,18.4,0.9z M19.4,0.5c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2-0.1
        		c0.1,0,0.1,0.1,0.2,0.1C19.5,0.4,19.4,0.5,19.4,0.5z M22.9,0.8c-0.1,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c0,0,0.1,0,0.1-0.1
        		C22.7,0.7,22.8,0.7,22.9,0.8z M49.4,0.7c-0.3,0.1-0.4,0-0.3-0.2C49.3,0.6,49.4,0.6,49.4,0.7z M63.1,0.6c0.1-0.1,0.3-0.2,0.6-0.1
        		C63.6,0.5,63.5,0.7,63.1,0.6z"
            />
            <path fill={color} d="M50.6,1.4c-0.1,0-0.2-0.1-0.3-0.2C50.2,1.4,50.3,1.4,50.6,1.4z" />
            <path fill={color} d="M64.8,1.3c0.4,0.1,0.5,0,0.6-0.1C65.1,1.1,64.9,1.2,64.8,1.3z" />
            <path
                fill={color}
                d="M11.7,1.6c0.1,0,0.2,0,0.2,0c0,0,0-0.1,0-0.1C11.7,1.4,11.6,1.4,11.7,1.6C11.6,1.5,11.7,1.5,11.7,1.6z"
            />
            <path fill={color} d="M10.8,1.4c0.1-0.1,0.2-0.1,0.3-0.2C10.6,1.2,10.6,1.2,10.8,1.4z" />
            <path
                fill={color}
                d="M8.6,1.4c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.1,0-0.1,0-0.2,0C8.6,1.3,8.6,1.4,8.6,1.4z"
            />
            <path
                fill={color}
                d="M5.9,1.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1C6.2,1.1,6.1,1.1,6,1C5.9,1.1,5.9,1.1,5.9,1.1z"
            />
            <path
                fill={color}
                d="M19.3,1.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1C19.4,1,19.3,1.1,19.3,1.1z"
            />
            <path
                fill={color}
                d="M22.8,1.5c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C22.9,1.4,22.8,1.4,22.8,1.5z"
            />
            <path
                fill={color}
                d="M26.7,1.9c0,0,0.1,0.1,0.2,0.1C26.9,2,27,2,27,1.9c0,0-0.1-0.1-0.2-0.2C26.8,1.9,26.7,1.9,26.7,1.9z"
            />
            <path
                fill={color}
                d="M18.3,1.6c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C18.3,1.5,18.3,1.5,18.3,1.6C18.2,1.6,18.3,1.6,18.3,1.6z"
            />
            <path
                fill={color}
                d="M17.5,1.5c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0.1,0.1,0.1,0.1C17.4,1.5,17.5,1.5,17.5,1.5z"
            />
            <path
                fill={color}
                d="M19.3,2c0.1,0,0.1,0,0.2-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.1C19.1,2,19.2,2,19.3,2z"
            />
        </g>
    </svg>
);

LineSmallerAlt.propTypes = propTypes;
LineSmallerAlt.defaultProps = defaultProps;

export default LineSmallerAlt;
